/**
 * DB 오류 글을 줄로 가른다 — 표시용. Oracle 은 오류 스택(ORA-20000 … ORA-06512 … ORA-06512 …)을 한 줄로 이어 주는 일이 많아
 * 그대로 그리면 한 줄이 화면 폭만큼 퍼져 읽기 어렵다(신고 2026-10-13). 코드(ORA-/PLS-/SP2-/TNS-…)마다 새 줄에서 시작하게 한다.
 * 글은 바꾸지 않는다(줄만 나눈다) — 복사하면 원문 그대로다.
 */
const CODE = /\s+(?=(?:ORA|PLS|SP2|TNS|DPI|DPY|NJS|IMP|EXP|KUP|LPX|RMAN)-\d{3,5}\b)/g;

export function errorLines(message) {
  const s = String(message == null ? '' : message);
  return s.split(/\r?\n/).flatMap(line => line.split(CODE)).map(l => l.trim()).filter(Boolean);
}

export default errorLines;
